import http from '~/http/index';

export default ({
  state: {
    data: {},
  },

  getters: {
  },

  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    async loadData({ commit }) {
      const response = await http.get('v2/Options/GetVerificationOptions');
      commit('SET_DATA', response.data);
    },

    async updateVerificationOptions(__store, data) {
      const response = await http.post('v2/Options/UpdateVerificationOptions', data);
      return response.data;
    },
  },

  namespaced: true,
});
